import React, { useState, useImperativeHandle } from 'react';
import useRetrieveData from 'global/hooks/useRetrieveData';
import ReassignModal from 'feature/task/TaskNotify/ReassignModal';
import { uniqBy, size, get } from 'global/lib/lodash';
import { Button } from 'global/components/Button';
import { Row } from 'global/components/row';
import { Icon } from '@material-ui/core';

export const UserSelectModal = React.forwardRef((props, ref) => {
  const [showModal, setShowModal] = useState({ open: false });
  // const [loading, setLoading] = useState(false);

  const [userParams] = useState({
    waitFor: props.realm_id,
    build: ['users'],
    params: { filter: { content_realm_id: props.realm_id } },
    useCache: { reload: 1 },
  });

  const users = useRetrieveData({ url: '/users' }, userParams);

  const displayModal = () => {
    return new Promise((resolve, reject) => {
      const assignees = uniqBy([...(users.data || [])], 'id');

      const onClose = (success) => {
        setShowModal({ open: false });
        document.getElementsByTagName('body')[0].style = '';
        if (!success) {
          reject(new Error('canceled'));
        }
      };

      const onSubmit = async (fs) => {
        onClose(true);
        resolve(fs);
      };

      setShowModal({
        open: true,
        title: 'Email Receipt',
        okButton: 'Update & Send',
        contentTitle: '',
        contentSub: 'Who would you like to send this status update to?',
        tasks: [{ assignees: props.assignees || [] }],
        assignees: assignees,
        assignedToProps: {
          label: 'Send To',
        },
        onClose,
        buttons: (p) => (
          <Row>
            <Button onClick={() => onSubmit(p.formState)} disabled={!size(get(p, 'formState.assignedTo', []))} loading={false} icon={<Icon>person_add</Icon>}>
              UPDATE AND SEND
            </Button>
          </Row>
        ),
      });
    });
  };

  useImperativeHandle(
    ref,
    () => ({
      displayModal,
    }),
    [users]
  );

  return <ReassignModal {...showModal} />;
});
